export default {

  baseURL: "?z=N5DoPQvfGnV7m/jLpswgSJMpZ1ezSiw0",

}